var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MAX_ALTERNATE_PHONES } from '../constants/general';
import { formatCityState } from '../components/shared/city-state-select/city-state-select';
import { getHyphenatedPhoneNumber, sanitizePhoneNumber } from './general';
export var findTradeTypeInfo = function (tradeTypes, tradeType) { return tradeTypes === null || tradeTypes === void 0 ? void 0 : tradeTypes.find(function (_a) {
    var type = _a.type;
    return type === tradeType;
}); };
var getCityStateObjectFromStr = function (value) { return ({
    city: value.split(', ')[0],
    state: value.split(', ')[1],
}); };
export var getDeleteAltPhonesPayload = function (values, companyData) {
    var _a, _b;
    return (_b = (_a = companyData === null || companyData === void 0 ? void 0 : companyData.companyDetails) === null || _a === void 0 ? void 0 : _a.altPhones) === null || _b === void 0 ? void 0 : _b.filter(function (_a) {
        var id = _a.id;
        return !values.alternatePhones.find(function (_a) {
            var formAltPhoneId = _a.id, number = _a.number;
            return id === formAltPhoneId && number;
        });
    });
};
var getAltPhonesForUpdatePayload = function (formAltPhones, removedAltPhones) {
    if (removedAltPhones === void 0) { removedAltPhones = []; }
    var filteredFormPhones = formAltPhones.filter(function (_a) {
        var number = _a.number;
        return !!number;
    });
    var combinedAltPhones = __spreadArray(__spreadArray([], removedAltPhones, true), filteredFormPhones, true).slice(0, MAX_ALTERNATE_PHONES);
    return combinedAltPhones.map(function (phone) { return (__assign(__assign({}, phone), { id: undefined, number: sanitizePhoneNumber(phone.number) })); });
};
var getPrimaryPhoneForPayload = function (values, companyData) {
    var _a;
    return (__assign(__assign({ type: 'WORK', primaryFlag: 'Y', secondaryFlag: 'N', preferenceType: null, infoPhoneTypes: null }, (_a = companyData.companyDetails) === null || _a === void 0 ? void 0 : _a.companyPhone), { number: sanitizePhoneNumber(values.companyPhone) }));
};
var getAddressToRequestModel = function (values, companyData) {
    var _a;
    var _b = getCityStateObjectFromStr(values.cityState), city = _b.city, state = _b.state;
    var address = (_a = companyData.response.accountProfile) === null || _a === void 0 ? void 0 : _a.customerProfile.address;
    return [
        __assign(__assign({ isDefault: true }, address === null || address === void 0 ? void 0 : address[0]), { postalDetails: {
                addressLine1: values.address,
                addressLine2: values.addressLine2 || undefined,
                city: city,
                country: 'US',
                state: state,
                zipCode: values.zipCode,
            } }),
    ];
};
export var mapCompanyFormToRequestModel = function (values, tradeTypes, companyData, failedAltPhones) {
    return {
        customerProfile: {
            businessName: values.companyName,
            taxExemptId: companyData.taxExemptId,
            address: getAddressToRequestModel(values, companyData),
            phones: __spreadArray([
                getPrimaryPhoneForPayload(values, companyData)
            ], (getAltPhonesForUpdatePayload(values.alternatePhones, failedAltPhones) || []), true),
            tradeType: findTradeTypeInfo(tradeTypes, values.businessType) ||
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                companyData.companyDetails.businessType,
        },
    };
};
export var getInitialCompanyDetailsValues = function (companyDetails) {
    var _a, _b, _c;
    return ({
        companyName: companyDetails.companyName,
        address: companyDetails.address,
        addressLine2: companyDetails.addressLine2 || '',
        companyPhone: getHyphenatedPhoneNumber(((_a = companyDetails.companyPhone) === null || _a === void 0 ? void 0 : _a.number) || ''),
        businessType: ((_b = companyDetails.businessType) === null || _b === void 0 ? void 0 : _b.type) || '',
        cityState: companyDetails.city && companyDetails.state
            ? formatCityState(companyDetails.city, companyDetails.state)
            : '',
        zipCode: companyDetails.zipCode,
        alternatePhones: ((_c = companyDetails.altPhones) === null || _c === void 0 ? void 0 : _c.map(function (phone) { return (__assign(__assign({}, phone), { number: getHyphenatedPhoneNumber((phone === null || phone === void 0 ? void 0 : phone.number) || '') })); })) || [],
    });
};
